import React from 'react';
import { Reveal } from './Reveal';
import { Section } from './Section';
import styles from './GrowthSection.module.css';

interface GrowthSectionProps {
  onPrimaryCtaClick: () => void;
}

export function GrowthSection({ onPrimaryCtaClick }: GrowthSectionProps) {
  return (
    <Section id="rast" title="Watch It Happen">
      <Reveal>
        <p className={styles.text}>
          Not a claim. Not a before-and-after. A real, daily process you witness —
          from the moment you plant to the moment you eat.
          This is what growth looks like when you slow down enough to notice it.
        </p>
      </Reveal>

      <Reveal delayMs={100}>
        <div className={styles.timelineImageWrap}>
          <div className={styles.dayLabels} aria-hidden="true">
          </div>
          <img
            src="/GROWTH_SEQUENCE.png"
            alt="Your ritual: from seed to harvest in 7 days"
            className={styles.timelineImage}
          />
          <div className={styles.imageGlow} aria-hidden="true" />
        </div>
      </Reveal>

      <Reveal>
        <div className={styles.ctaWrap}>
          <p className={styles.ctaText}>Ready to start yours?</p>
          <button type="button" className={styles.cta} onClick={onPrimaryCtaClick}>
            Start My Ritual — $49
          </button>
        </div>
      </Reveal>
    </Section>
  );
}
